module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: " ml30 mr30"
  }, [_c('div', {
    staticClass: " mb15 row flex-start"
  }, [_c('div', {
    staticClass: "row flex-start"
  }, [_c('div', [_vm._v("场地名称：")]), _vm._v(" "), _c('el-select', {
    ref: "selectValue1",
    staticClass: "mr25",
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.optionValueChange
    },
    model: {
      value: (_vm.optionValue),
      callback: function($$v) {
        _vm.optionValue = $$v
      },
      expression: "optionValue"
    }
  }, _vm._l((_vm.optionList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row flex-between mt15 mb15"
  }, [_c('div', {
    staticClass: "row flex-start"
  }, [_c('div', {
    staticClass: " row flex-center font24 grey6_text cursorp white_bg mr15",
    staticStyle: {
      "width": "180px",
      "height": "60px",
      "border": "1px solid rgba(227, 232, 238, 1)"
    },
    on: {
      "click": function($event) {
        return _vm.onEdit('new')
      }
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('div', {
    staticClass: " row flex-center font24 grey6_text cursorp white_bg mr15",
    staticStyle: {
      "width": "180px",
      "height": "60px",
      "border": "1px solid rgba(227, 232, 238, 1)"
    },
    on: {
      "click": function($event) {
        return _vm.onEdit()
      }
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('div', {
    staticClass: " row flex-center font24 grey6_text cursorp white_bg mr15",
    staticStyle: {
      "width": "180px",
      "height": "60px",
      "border": "1px solid rgba(227, 232, 238, 1)"
    },
    on: {
      "click": function($event) {
        return _vm.onGuige()
      }
    }
  }, [_vm._v("添加规格")]), _vm._v(" "), _c('div', {
    staticClass: " row flex-center font24 grey6_text cursorp white_bg mr15",
    staticStyle: {
      "width": "180px",
      "height": "60px",
      "border": "1px solid rgba(227, 232, 238, 1)"
    },
    on: {
      "click": function($event) {
        return _vm.editFuc('ENABLE')
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('div', {
    staticClass: " row flex-center font24 grey6_text cursorp white_bg mr15",
    staticStyle: {
      "width": "180px",
      "height": "60px",
      "border": "1px solid rgba(227, 232, 238, 1)"
    },
    on: {
      "click": function($event) {
        return _vm.editFuc('DISABLE')
      }
    }
  }, [_vm._v("禁用")])])]), _vm._v(" "), [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    attrs: {
      "element-loading-background": "rgba(255, 255, 255, .5)",
      "element-loading-text": _vm.loadText,
      "element-loading-spinner": "el-icon-loading",
      "height": _vm.recoData.recParams.page_size == 10 ? 570 : 570,
      "data": _vm.recoData.list,
      "row-style": _vm.rowStyle
    },
    on: {
      "row-click": _vm.changeCurrentRow
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "Num",
      "label": "货物编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Name",
      "label": "货物名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Comment",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "guigedetail",
      "label": "规格数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Valid",
      "label": "启用/禁用"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.Valid == 1) ? _c('span', {
          staticClass: "green_text"
        }, [_vm._v("已启用")]) : _vm._e(), _vm._v(" "), (scope.row.Valid == 0) ? _c('span', {
          staticClass: "red_text"
        }, [_vm._v("已禁用")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row flex-between"
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "row flex-start font12"
  }, [_c('el-pagination', {
    staticStyle: {
      "margin": "20px 0 20px 0"
    },
    attrs: {
      "background": "",
      "layout": "total,sizes,prev, pager, next",
      "page-size": _vm.recoData.recParams.page_size,
      "page-sizes": [10, 20, 30, 40, 50, 100, 200, 500, 1000, 2000],
      "total": _vm.recoData.total,
      "popper-class": "select_bottom"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    },
    model: {
      value: (_vm.recoData.recParams.page_size),
      callback: function($$v) {
        _vm.$set(_vm.recoData.recParams, "page_size", $$v)
      },
      expression: "recoData.recParams.page_size"
    }
  })], 1)])], _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.show02,
      "close-on-click-modal": true,
      "append-to-body": "true"
    },
    on: {
      "update:visible": function($event) {
        _vm.show02 = $event
      },
      "closed": _vm.handleClose
    }
  }, [_c('el-form', {
    ref: "ruleForm2",
    attrs: {
      "model": _vm.form2,
      "rules": _vm.rules2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.addLenght
    }
  }, [_vm._v("添加规格")]), _vm._v(" "), _c('div', {
    staticClass: "mb10"
  }), _vm._v(" "), _c('el-table', {
    ref: "tableDemo",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.form2.tableData,
      "cell-style": {
        background: '#fff'
      },
      "row-style": _vm.rowStyle,
      "element-loading-background": "rgba(255, 255, 255, .5)",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "55",
      "label": "序号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "规格",
      "prop": "name",
      "min-width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          attrs: {
            "prop": 'tableData.' + scope.$index + '.name',
            "rules": _vm.rules2.name
          }
        }, [_c('el-input', {
          model: {
            value: (scope.row.name),
            callback: function($$v) {
              _vm.$set(scope.row, "name", $$v)
            },
            expression: "scope.row.name"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.removeItem(scope.$index)
            }
          }
        }, [_vm._v("删除")])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.show02 = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveGuige()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.show01,
      "close-on-click-modal": false,
      "append-to-body": "true"
    },
    on: {
      "update:visible": function($event) {
        _vm.show01 = $event
      },
      "closed": _vm.handleClose
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "物资编号",
      "prop": "Num",
      "min-width": "290"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.Num),
      callback: function($$v) {
        _vm.$set(_vm.form, "Num", $$v)
      },
      expression: "form.Num"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "物资名称",
      "prop": "Name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.Name),
      callback: function($$v) {
        _vm.$set(_vm.form, "Name", $$v)
      },
      expression: "form.Name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.Comment),
      callback: function($$v) {
        _vm.$set(_vm.form, "Comment", $$v)
      },
      expression: "form.Comment"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.show01 = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (_vm.title == '新增物资') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editFuc('NEW')
      }
    }
  }, [_vm._v("确 定")]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editFuc()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ed311bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Material.vue
// module id = 1081
// module chunks = 1